export type WatchlistListFilterId = 'all' | 'uncategorized' | `l-${number}`

export function parseWatchlistListFilter(raw: string | null): WatchlistListFilterId {
  if (raw === 'uncategorized') return 'uncategorized'
  if (raw && /^\d+$/.test(raw)) return `l-${Number(raw)}`
  return 'all'
}

export function serialiseWatchlistListFilter(id: WatchlistListFilterId): string | null {
  if (id === 'all') return null
  if (id === 'uncategorized') return 'uncategorized'
  return id.slice(2)
}
